import { render } from "./ManageReminders.vue?vue&type=template&id=3fddc2c3&scoped=true"
import script from "./ManageReminders.vue?vue&type=script&lang=js"
export * from "./ManageReminders.vue?vue&type=script&lang=js"

import "./ManageReminders.vue?vue&type=style&index=0&id=3fddc2c3&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fddc2c3"]])

export default __exports__